<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/config/craft/template/page"
			getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('zhanshifangshi')">
						<yi_dictionary_select :type="'EQUIPMENT_CRAFT_TEMPLATE_TYPE'" :ids.sync="yt.conditions.type">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item :label="$t('shujumoban')">
						<yi_cross_select :max="1" :component="'admin_data_template_protocol_list'"
							:ids.sync="yt.conditions.templateId">
						</yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('shebeiSN')">
						<yi_cross_select :selectTitle="'sn'" :component="'web_base_equipment_list'"
							:ids.sync="yt.conditions.equipmentId">
						</yi_cross_select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1,null,afterGet)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear({orderBy:'createTime desc'})">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1',beforeShowEditDialog)"
					type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text"
							@click="yt.showEditDialog('bianji', scope.row,'w1',beforeShowEditDialog)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/config/craft/template/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
			<template #zhanshineirong="scope">
				<span>{{ base64.decode(scope.row.showJson)}}</span>
			</template>
			<!-- 底部插槽 -->
			<!-- <div slot="footer"></div> -->
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<div :class="(yt.editObj.type == 1 || yt.editObj.type == 2)?'dialog-scroller' : ''">
					<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
						<el-form-item :label="$t('zhanshifangshi')" required>
							<el-select v-model="yt.editObj.type">
								<el-option :label="$t('anshujumoban')" :value="1"></el-option>
								<el-option :label="$t('anshebei')" :value="2"></el-option>
							</el-select>
						</el-form-item>
						<div v-if="yt.editObj.type == 1">
							<el-form-item :label="$t('shujumoban')" required>
								<!-- <yi_dictionary_select :type="'EQUIPMENT_CRAFT_TEMPLATE_TYPE'"
								:ids.sync="yt.editObj.templateId">
							</yi_dictionary_select> -->
								<yi_cross_select :max="1" :component="'admin_data_template_protocol_list'"
									:ids.sync="yt.editObj.templateId">
								</yi_cross_select>
							</el-form-item>
							<el-form-item :label="$t('zhanshineirong')" required>
								<el-input :placeholder="$t('qingshuruJSONwenben')" v-model="yt.editObj.showJsonTmp"
									type="textarea" maxlength="50000" show-word-limit
									:autosize="{ minRows: 8, maxRows: 8}">
								</el-input>
							</el-form-item>
							<el-form-item :label="$t('fenleizhanshineirong')" required>
								<el-input :placeholder="$t('qingshuruJSONwenben')" v-model="yt.editObj.classifiedJson"
									type="textarea" maxlength="50000" show-word-limit
									:autosize="{ minRows: 8, maxRows: 8}">
								</el-input>
							</el-form-item>
						</div>
						<div v-else-if="yt.editObj.type == 2">
							<el-form-item :label="$t('shebeiSN')" required="required">
								<yi_cross_select :selectTitle="'sn'" :component="'web_base_equipment_list'" :max="1"
									:ids.sync="yt.editObj.equipmentId">
								</yi_cross_select>
							</el-form-item>
							<el-form-item :label="$t('zhanshineirong')" required>
								<el-input :placeholder="$t('qingshuruJSONwenben')" v-model="yt.editObj.showJsonTmp"
									type="textarea" maxlength="50000" show-word-limit
									:autosize="{ minRows: 8, maxRows: 8}">
								</el-input>
							</el-form-item>
							<el-form-item :label="$t('fenleizhanshineirong')" required>
								<el-input :placeholder="$t('qingshuruJSONwenben')" v-model="yt.editObj.classifiedJson"
									type="textarea" maxlength="50000" show-word-limit
									:autosize="{ minRows: 8, maxRows: 8}">
								</el-input>
							</el-form-item>
						</div>

					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/config/craft/template/create', beforeAdd)"
						type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<div class="dialog-scroller">
					<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
						<el-form-item :label="$t('zhanshifangshi')" required>
							<el-select disabled v-model="yt.editObj.type">
								<el-option :label="$t('anshujumoban')" :value="1"></el-option>
								<el-option :label="$t('anshebei')" :value="2"></el-option>
							</el-select>
						</el-form-item>
						<div v-if="yt.editObj.type == 1">
							<el-form-item :label="$t('shujumoban')" required>
								<yi_cross_select :max="1" :component="'admin_data_template_protocol_list'"
									:ids.sync="yt.editObj.templateId">
								</yi_cross_select>
							</el-form-item>
							<el-form-item :label="$t('zhanshineirong')" required>
								<el-input v-model="yt.editObj.showJsonTmp" type="textarea" maxlength="50000"
									show-word-limit :autosize="{ minRows: 8, maxRows: 8}">
								</el-input>
							</el-form-item>
							<el-form-item :label="$t('fenleizhanshineirong')" required>
								<el-input v-model="yt.editObj.classifiedJson" type="textarea" maxlength="50000"
									show-word-limit :autosize="{ minRows: 8, maxRows: 8}">
								</el-input>
							</el-form-item>
						</div>
						<div v-else-if="yt.editObj.type == 2">
							<el-form-item :label="$t('shebeiSN')" required="required">
								<yi_cross_select disabled :selectTitle="'sn'" :component="'web_base_equipment_list'"
									:max="1" :ids.sync="yt.editObj.equipmentId">
								</yi_cross_select>
							</el-form-item>
							<el-form-item :label="$t('zhanshineirong')" required>
								<el-input v-model="yt.editObj.showJsonTmp" type="textarea" maxlength="50000"
									show-word-limit :autosize="{ minRows: 8, maxRows: 8}">
								</el-input>
							</el-form-item>
							<el-form-item :label="$t('fenleizhanshineirong')" required>
								<el-input v-model="yt.editObj.classifiedJson" type="textarea" maxlength="50000"
									show-word-limit :autosize="{ minRows: 8, maxRows: 8}">
								</el-input>
							</el-form-item>
						</div>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/config/craft/template/update',beforeAdd)"
						type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	const Base64 = require('js-base64').Base64
	export default {
		name: 'admin_data_template_technology_list',
		data() {
			return {
				base64: Base64,
				columns: [{
						label: 'zhanshifangshi',
						type: 'dictionary',
						key: 'EQUIPMENT_CRAFT_TEMPLATE_TYPE',
						prop: 'type',
						width: 130
					}, {
						label: 'shujumoban',
						prop: 'template.name',
						width: 130
					},
					{
						label: 'shebeiSN',
						prop: 'equipment.sn'
					}, {
						label: 'zhanshineirong',
						// prop: 'showJson',
						type: 'slot',
					},
					{
						label: 'fenleizhanshineirong',
						prop: 'classifiedJson',

					}, {
						label: 'caozuo',
						type: 'slot',
						width: 130,
						fixed: 'right'
					}
				]
			};
		},
		watch: {
			'yt.editObj.action'(value) {
				if (value === 'bianji') {
					this.$nextTick(() => {
						this.$set(this.yt.editObj, 'showJsonTmp', this.base64.decode(this.yt.editObj.showJsonTmp))
					});

				}
			}

		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
					orderBy: 'createTime desc',
				}
				this.yt.get(1);
			}, 300)

		},

		methods: {
			beforeShowEditDialog(params) {
				params.showJsonTmp = params.showJson
				return params
			},

			beforeAdd(params) {
				params.showJson = this.base64.encode(params.showJsonTmp)
				return params
			}
		}
	};
</script>
